<template>
	<div class="personer">
		<div>
			<!-- <svg t="1620206845175" class="icon" viewBox="0 0 1024 1024" version="1.1"
				xmlns="http://www.w3.org/2000/svg" p-id="2069" width="16" height="16">
				<path d="M623.1 604.2c-4.7 0-37.3-18.2-18.6-77.4 51.2-54.6 93.1-141.1 93.1-223 0-132-88.5-200.2-186.3-200.2-102.4 0-186.3 68.3-186.3 200.2 0 86.5 41.9 172.9 93.1 227.5 18.6 50.1-18.6 72.8-27.9 72.8C287.8 645.1 162 713.3 162 781.6V809c0 91 181.6 113.8 349.2 113.8S860.6 900 860.6 809v-27.3c0-72.8-125.7-141.1-237.5-177.5z m0 0"
					fill="#1296db" p-id="2070"></path>
			</svg> -->
			<span>
				{{name || ''}}
			</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'personer',
		props: {
			name:{
				type: String,
				default: '',
			},
		},
		data(){
			return {
				
			}
		},
	}
</script>

<style scoped lang="scss">
	.personer{
		border:none;
		
	}
	
</style>